import React from 'react';
import { Button, Dialog, DialogProps, Group } from '@economic/taco';
import { Trans } from '@lingui/macro';

interface Props extends Partial<DialogProps> {
    onClose: () => void;
    onConfirm: () => void;
    isAdministrator: boolean;
}

export const SuperUserConfirmationDialog = ({ onClose, onConfirm, isAdministrator, ...dialogProps }: Props) => {
    return (
        <Dialog onClose={onClose} {...dialogProps} size="xs">
            <Dialog.Content aria-label="enable super users access to addons dialog">
                <Dialog.Title>
                    {isAdministrator ? (
                        <Trans>Enable Super Users to manage add-ons</Trans>
                    ) : (
                        <Trans>Enable Super User to manage add-ons</Trans>
                    )}
                </Dialog.Title>
                {isAdministrator ? (
                    <Trans>
                        Be aware that this affects all agreements for which your Admin agreement owns the invoicing. By enabling
                        this setting the Super User on these agreements will be able to add new, update or remove existing
                        add-ons.
                    </Trans>
                ) : (
                    <Trans>
                        Be aware that your Admin owns the invoicing of this e-conomic agreement. By enabling this setting the
                        Super User will be able to add, update and remove add ons.
                    </Trans>
                )}
                <Dialog.Footer>
                    <Group>
                        <Button appearance="default" onClick={onClose}>
                            <Trans>Close</Trans>
                        </Button>
                        <Button appearance="primary" autoFocus onClick={onConfirm}>
                            <Trans>Ok</Trans>
                        </Button>
                    </Group>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
};
